import React from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import Popup from "../../../components/Popups/Popup";
import Translate from "../../../components/Translate";
import { useNotifications } from "../../../contexts/notificationContext";
import BillOfMaterialItemFileModel from "../../../models/BillOfMaterialItemFileModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";

interface IProps extends PopupProps {
    billOfMaterialItemFile: BillOfMaterialItemFileModel
}

const DeleteReferencePicturePopup: React.FC<IProps> = ({ show, onHide, billOfMaterialItemFile }) => {
    const { handleResult, handleException } = useNotifications();

    function submit() {
        DataService
            .delete('api/v1/BillOfMaterialItemFiles/', billOfMaterialItemFile.id)
            .then(response => {
                handleResult(response);
                if (response.isSuccesful === true) {
                    onHide();
                }
            })
            .catch(e => handleException(e));
    }

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Delete reference picture'} >
            <Popup.Body>
                <img height='250' src={billOfMaterialItemFile.url}></img>
                <p><Translate>Are you sure you want to delete this reference picture?</Translate></p>
            </Popup.Body>
            <Popup.Footer>
                <SaveButton onClick={submit} text='Delete' variant='danger' />
            </Popup.Footer>
        </Popup>
    );
}
export default DeleteReferencePicturePopup;
